// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductAnalog.module.scss  */
.ProductAnalog-module-Root_37- {
  display: flex;
  align-items: center;
  width: auto;
  padding: 0 0 9px;
  font-family: var(--display-font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 22px; }

.ProductAnalog-module-Icon_3Lt {
  margin-left: 8px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Analog/ProductAnalog.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE;;AAErB;EACE,gBAAgB,EAAE","sourcesContent":["/*  imported from ProductAnalog.module.scss  */\n.ProductAnalog-module-Root_37- {\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 0 0 9px;\n  font-family: var(--display-font-family);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px; }\n\n.ProductAnalog-module-Icon_3Lt {\n  margin-left: 8px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
